import React, { useState } from "react";
import { Dialog } from "evergreen-ui";
import styles from "./CollectionSteps.module.scss";
import { formatCurrency } from "../../../utils";
import toast from "react-hot-toast";

const documents = [
  "Voters card",
  "National Id Card",
  "Driver's license",
  "Passport",
];

const DeliverWithId = ({
  show,
  order,
  handleUpdateStatus,
  updating,
  fail,
  setShowAltModal,
  close,
}) => {
  const [deliveryId, setDeliveryId] = useState("");
  const [idType, setIDType] = useState("");
  const [nameOnId, setNameOnId] = useState("");
  const [submiting, setSubmitting] = useState(false);

  const handleSubmitWithID = async () => {
    if (!idType) {
      toast.error("ID Type is required");
      return;
    }

    if (!deliveryId.trim()) {
      toast.error("ID number is required");
      return;
    }

    if (!nameOnId.trim()) {
      toast.error("Name on ID card is required");
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        orderId: order.orderId,
        number: deliveryId,
        type: idType,
        receiverName: nameOnId,
      };
      const token = localStorage.getItem("pos-token");

      const response = await fetch(
        "https://api.abccargoxpress.com/api/v1/Orders/SetDeliveryByIdentification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to submit order");
      }

      await response.json();
      toast.success("Success!");

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      console.error("Error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (event) => {
    setIDType(event.target.value);
  };

  return (
    <Dialog
      isShown={show}
      title="Deliver with ID"
      onCloseComplete={close}
      hasFooter={false}
    >
      <div>
        <p>
          <strong>Order ID: </strong> {order?.orderId}
        </p>

        <p>
          <strong>Amount paid: </strong> {formatCurrency(order?.totalAmount)}
        </p>
      </div>
      <div className={styles.altModal}>
        <small>{fail}</small>

        <div>
          <label htmlFor="document">ID Type</label>
          <select onChange={handleChange} id="document" name="document">
            <option>Select ID Type</option>
            {documents.map((doc, index) => (
              <option key={index} value={doc.toLowerCase()}>
                {doc}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="delivery-id">ID Number </label>
          <input
            id="delivery-id"
            type="text"
            value={deliveryId}
            onChange={(e) => setDeliveryId(e.target.value)}
            placeholder="ID"
          />
        </div>
        <div>
          <label htmlFor="id-name">Name on ID</label>
          <input
            id="id-name"
            type="text"
            value={nameOnId}
            onChange={(e) => setNameOnId(e.target.value)}
            placeholder="Full Name"
          />
        </div>

        {/* {deliveryIdError && (
          <small className={styles.errorMsg}>{deliveryIdError}</small>
        )} */}

        <div className={styles.modalActions}>
          <button onClick={handleSubmitWithID} disabled={updating || submiting}>
            {updating ? "Submitting..." : "Submit ID"}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeliverWithId;
